import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Google Analytics 4 loader — fetches the `ga_measurement_id` from site_settings
 * and injects the gtag script + page-view configuration. Idempotent.
 */
export default function GoogleAnalytics() {
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/site-settings`)
      .then((r) => {
        if (cancelled) return;
        const id = (r.data && r.data.ga_measurement_id) || "";
        if (!id || !/^G-[A-Z0-9]+$/i.test(id)) return;
        if (document.getElementById("ga4-loader")) return; // idempotent

        // 1) async loader
        const s1 = document.createElement("script");
        s1.id = "ga4-loader";
        s1.async = true;
        s1.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
        document.head.appendChild(s1);

        // 2) config
        const s2 = document.createElement("script");
        s2.id = "ga4-config";
        s2.textContent = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${id}', { anonymize_ip: true });
        `;
        document.head.appendChild(s2);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return null;
}
